__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "_N_E";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("./core/AppContext/index.tsx", "0", function() { return Promise.all([__webpack_require__.e(9774), __webpack_require__.e(2438)]).then(function() { return function() { return __webpack_require__(2438); }; }); });
			register("./core/theme/NovaThemeProvider.tsx", "0", function() { return Promise.all([__webpack_require__.e(9774), __webpack_require__.e(917), __webpack_require__.e(9437), __webpack_require__.e(8357)]).then(function() { return function() { return __webpack_require__(54821); }; }); });
			register("@emotion/react", "11.14.0", function() { return __webpack_require__.e(917).then(function() { return function() { return __webpack_require__(70917); }; }); });
			register("next/dynamic", "13.1.6", function() { return __webpack_require__.e(5152).then(function() { return function() { return __webpack_require__(5152); }; }); });
			register("next/head", "13.1.6", function() { return __webpack_require__.e(9008).then(function() { return function() { return __webpack_require__(9008); }; }); });
			register("next/link", "13.1.6", function() { return __webpack_require__.e(1664).then(function() { return function() { return __webpack_require__(41664); }; }); });
			register("next/router", "13.1.6", function() { return __webpack_require__.e(1163).then(function() { return function() { return __webpack_require__(11163); }; }); });
			register("next/script", "13.1.6", function() { return __webpack_require__.e(4298).then(function() { return function() { return __webpack_require__(4298); }; }); });
			register("react-dom", "18.3.1", function() { return function() { return __webpack_require__(73935); }; });
			register("react-router-dom", "6.5.0", function() { return Promise.all([__webpack_require__.e(9250), __webpack_require__.e(9655)]).then(function() { return function() { return __webpack_require__(79655); }; }); });
			register("react/jsx-runtime", "18.3.1", function() { return __webpack_require__.e(9774).then(function() { return function() { return __webpack_require__(85893); }; }); });
			register("react", "18.3.1", function() { return function() { return __webpack_require__(67294); }; });
			register("styled-jsx/style", "5.1.1", function() { return Promise.all([__webpack_require__.e(2470), __webpack_require__.e(1857)]).then(function() { return function() { return __webpack_require__(51857); }; }); });
			register("styled-jsx", "5.1.1", function() { return Promise.all([__webpack_require__.e(2470), __webpack_require__.e(9528)]).then(function() { return function() { return __webpack_require__(49528); }; }); });
			initExternal(76449);
			initExternal(93919);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};